import settingsIcon from '../../assets/icons/settings.svg';
import salesIcon from '../../assets/icons/shopping-bag.svg';
import calendarIcon from '../../assets/icons/calendarSidebarIcon.svg';
import chatIcon from '../../assets/icons/chat-icon.svg';
import customersIcon from '../../assets/icons/customers-icon.svg';
import reportsIcon from '../../assets/icons/reports-icon.svg';

export type SidebarEl = {
  label: string;
  icon: string;
  navigateTo?: string;
  subItems?: Array<{ label: string; navigateTo: string }>;
};

export const SIDEBAR_ELEMENTS = [
  {
    label: 'schedule',
    icon: calendarIcon,
    navigateTo: '/web/schedule',
  },
  {
    label: 'customers',
    icon: customersIcon,
    navigateTo: '/web/sales/customers',
  },
  {
    label: 'sidebar.chat',
    icon: chatIcon,
    navigateTo: '/web/chat',
  },
  {
    label: 'sidebar.sales',
    navigateTo: '/web/sales/orders',
    icon: salesIcon,
  },
  {
    label: 'reports',
    icon: reportsIcon,
    navigateTo: '/web/reports',
  },
  {
    label: 'sidebar.settings',
    icon: settingsIcon,
    subItems: [
      {
        label: 'calendar',
        navigateTo: '/web/calendar',
      },
      {
        label: 'support',
        navigateTo: '/web/support',
      },
    ],
  },
];
